import React from 'react';
import "react-step-progress-bar/styles.css";
import './ProgressView.less'
import BinIcon from '../../images/bin_icon.png';
import { withTranslation } from 'react-i18next';
import { ProgressBar, Step } from "react-step-progress-bar";

class ProgressView extends React.Component {

    static defaultProps = {
        files: [],
        deleteModel: function(){}
      };
    constructor(props) {
        super(props);

        this.state = {
          files: this.props.files,
        };
    }

    componentDidUpdate(prevProps, prevState){              
        if (prevProps.files.length !== this.props.files.length) {          
          this.setState({files: this.props.files})
        }
        else
        {
          var equal = true;
          this.state.files.forEach((e) => 
          {
            var finding = this.props.files.find((f) => e.ItemID === f.ItemID && e.State === f.State && e["UploadProgress"] === f["UploadProgress"]);
            if (finding == null)
            {
              equal = false;
            }            
          })
          if (!equal)
          {            
            this.setState({files: this.props.files.slice()})
          }          
        }
      }
      
      removeJob(itemID)
      {
        this.props.deleteModel(itemID);
      }

      getStateDesciption(loadState){
        const { t } = this.props;
        if(loadState < 0){
          return t('LoadError');
        }else{
          switch(loadState){
            case 0:
              return t('Uploading');
            case 1:
              return t('LoadUploadFinished');
            case 2:
              return t('LoadQueued');
            case 3:
              return t('LoadServerGetFiles');
            case 4:
              return t('LoadConvert');
            case 5:
              return t('LoadDeploy');
            default:
              return t('LoadError');
          }
        }
      }

    render() {
        const { t } = this.props;
        var canClose = this.props.files != null ? this.props.files.find((f) => f.State === 0) == null : false;
        return (
            <div className='ProgressViewMain'>
                <div className='ProgressViewHeader'>
                    <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
                    <div className='ProgressHeaderInner'>
                        <p className='ProgressDescription'>{canClose ? t('WindowCloseAllow') : t('WindowCloseWarning')}</p>
                        <div className='WhiteLine'/>                        
                    </div>
                </div>    
                <div className='ProgressHeaderBody'>
                    { this.state.files != null && this.state.files.map((data, idx) =>
                    {
                        var progress = data["State"]/6*100;//data["Progress"] + "%";
                        var description = this.getStateDesciption(data["State"]);                        
                        if (data["State"] === 0 && data["UploadProgress"])
                        {
                          progress = data["UploadProgress"] / 3.0 * 100;
                          description += " (" + Math.floor( progress * 3 ) + "%)";
                        }
                        var filedisplay = data["Description"] === "" ? data["FileName"].endsWith("_") ? data["FileName"].substring(0, data["FileName"].length -1) : data["FileName"] : data["Description"];
                          
                        return (
                        <div className='FileRow' key={idx+1}>
                        <div className='FileRowInner' title={filedisplay}>
                            <div className='Filename'>
                                <p>{filedisplay.length > 17 ? filedisplay.slice(0, 16) + "..." : filedisplay}</p>
                            </div>
                            <div className='FileProgress'>
                                <div className='Paragraph'>{description}</div>                                
                                <ProgressBar
                                  percent={progress}
                                  hasStepZero={false}                                  
                                  filledBackground="linear-gradient(to right, #88A8A8, #6E9E9E)"
                                > 
                                <Step>
                                    {({ accomplished }) => (
                                      <div
                                      style={{ 
                                        display: "none",
                                        width: "10px",
                                        border: "solid 2px white",
                                        backgroundColor: "rgba(138, 173, 173)",
                                        borderRadius: "50%"}}
                                    >
                                      &nbsp;
                                      </div>
                                    )}
                                  </Step>
                                  <Step>
                                  {({ accomplished }) => (
                                      <div
                                      style={{ 
                                        filter: `grayscale(${accomplished ? 0 : 80}%)`,
                                        border: "transparent",
                                        width: "3px",
                                        height: "10px",
                                        //border: "solid 2px white",
                                        backgroundColor: "rgba(255, 255, 255, 0.6)",
                                        //borderRadius: "50%"
                                      }}
                                    >
                                      &nbsp;
                                      </div>
                                    )}
                                  </Step>
                                  <Step>
                                  {({ accomplished }) => (
                                      <div
                                      style={{ 
                                        filter: `grayscale(${accomplished ? 0 : 80}%)`,
                                        border: "transparent",
                                        width: "3px",
                                        height: "10px",
                                        //border: "solid 2px white",
                                        backgroundColor: "rgba(255, 255, 255, 0.6)",
                                        //borderRadius: "50%"
                                      }}
                                    >
                                      &nbsp;
                                      </div>
                                    )}
                                  </Step>
                                  <Step>
                                  {({ accomplished }) => (
                                      <div
                                      style={{ 
                                        filter: `grayscale(${accomplished ? 0 : 80}%)`,
                                        border: "transparent",
                                        width: "3px",
                                        height: "10px",
                                        //border: "solid 2px white",
                                        backgroundColor: "rgba(255, 255, 255, 0.6)",
                                        //borderRadius: "50%"
                                      }}
                                    >
                                      &nbsp;
                                      </div>
                                    )}
                                  </Step>
                                  <Step>
                                  {({ accomplished }) => (
                                      <div
                                      style={{ 
                                        filter: `grayscale(${accomplished ? 0 : 80}%)`,
                                        border: "transparent",
                                        width: "3px",
                                        height: "10px",
                                        //border: "solid 2px white",
                                        backgroundColor: "rgba(255, 255, 255, 0.6)",
                                        //borderRadius: "50%"
                                      }}
                                    >
                                      &nbsp;
                                      </div>
                                    )}
                                  </Step>                                 
                                  <Step>
                                  {({ accomplished }) => (
                                      <div
                                      style={{ 
                                        display: "none",
                                        width: "10px",
                                        border: "solid 2px white",
                                        backgroundColor: "rgba(138, 173, 173)",
                                        borderRadius: "50%"}}
                                    >
                                      &nbsp;
                                      </div>
                                    )}
                                  </Step>
                                </ProgressBar>
                                {
                                  /*
                                
                                <div className='ProgressBarOuter'>
                                    <div style={{width: progress}} className='ProgressBarInner'>
                                    </div>
                                </div>
                                */}
                            </div>
                        </div>
                        <button className='fileRemButton' title={t('Delete')} onClick={(e)=> {this.removeJob(data["ItemID"]);}}><img alt={t('Delete')} src={BinIcon}/></button>
                    </div>);
                    })}
                    
                </div>            
            </div>
        );
    }
}

export default withTranslation()(ProgressView);
